/**
 * The /interview funnel: Decision, then bestyou, height-weight and priority,
 * before /result. Each step reads its position and next hop from here rather
 * than hardcoding them.
 */

export const CONTROL_FLOW = {
    id: 'control',
    hideNavigation: false,
    entryPath: '/interview',
    steps: [
        '/interview',
        '/interview/bestyou',
        '/interview/height-weight',
        '/interview/priority'
    ]
};

/**
 * Called by landing CTAs on their way into the funnel; navigate to the
 * returned flow's entryPath.
 *
 * @returns {{ id: string, hideNavigation: boolean, entryPath: string, steps: string[] }}
 */
export function startInterview() {
    return CONTROL_FLOW;
}

export function getInterviewFlow() {
    return CONTROL_FLOW;
}

// The three helpers below are total: a path that is not part of the given flow
// returns a safe value rather than undefined. navigate(undefined) is read by
// react-router as navigate(0), which reloads the page — a loop with no exit.

export function stepPosition(flow, path) {
    const index = flow.steps.indexOf(path);
    return index === -1 ? 1 : index + 1;
}

export function nextStep(flow, path) {
    const index = flow.steps.indexOf(path);
    return index === -1 ? null : flow.steps[index + 1] ?? null;
}

export function previousStep(flow, path) {
    const index = flow.steps.indexOf(path);
    return index <= 0 ? null : flow.steps[index - 1];
}
